import { revealCardRegions, waitForCardElement } from '../../use/useBoardResidency';
import { Action } from '@/_core/fluxstore/types';
import { nextTick } from '@/_core/utils/nextTick';
import { StorymapState } from '../../types';
import { getActiveCard, getCardById, isSubtask, isTask } from '../../use';
import { useStorymapStore } from '../../useModule';
import { SetActiveCardIdByClick } from '../cardSelection/setActiveCardIdByClick';
import { SetReleaseIsCollapsed } from '../releases/setReleaseIsCollapsed';
import { SetActivityIsCollapsed } from '../setActivityIsCollapsed';

const { registerMiddleware, dispatch } = useStorymapStore();

export class TrySelectRestoredCardFromTrash extends Action<StorymapState> {
    public static ACTION_TYPE = 'TrySelectRestoredCardFromTrash';
    public wasSelected = false;

    public constructor(public cardId: string) {
        super(TrySelectRestoredCardFromTrash.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: TrySelectRestoredCardFromTrash): Promise<boolean> => {
    const card = getCardById(action.cardId);
    if (!card) {
        action.wasSelected = false;
        return false;
    }

    if (isSubtask(card) && state.releases.some((x) => x.id === card.releaseId)) {
        await dispatch(new SetReleaseIsCollapsed(card.releaseId, false));
    }
    if (isTask(card) || isSubtask(card)) {
        await dispatch(new SetActivityIsCollapsed(card.activityId, false));
    }

    if (isSubtask(card)) {
        revealCardRegions(card.releaseId, card.activityId);
    }
    // Null as well when the board was replaced in the meantime.
    const element = await waitForCardElement(action.cardId);
    if (!element || !getRenderedCardElement(action.cardId)) {
        action.wasSelected = false;
        return false;
    }

    await dispatch(new SetActiveCardIdByClick(action.cardId, { flashCard: true }));
    await nextTick();
    await new Promise((resolve) => setTimeout(resolve, 0));

    action.wasSelected = getActiveCard()?.id === action.cardId && !!getRenderedCardElement(action.cardId);
    return false;
};

const getRenderedCardElement = (cardId: string): HTMLElement | null =>
    document.getElementById(`subtask-${cardId}`) ||
    document.getElementById(`task-${cardId}`) ||
    document.getElementById(`activity-${cardId}`);

//@ts-ignore
registerMiddleware(TrySelectRestoredCardFromTrash.ACTION_TYPE, middleware);
